import DatePicker from 'react-datepicker'
import ptBR from 'date-fns/locale/pt-BR'

export function CustomInputDate(props) {
  return (
    <DatePicker
      {...props}
      className="form-control"
      dateFormat="dd/MM/yyyy"
      locale={ptBR}
    />
  )
}
